<template>
  <div :class="darkMode ? 'dark-mode' : ''">
    <div class="min-h-screen bg-gray-100 dark:bg-gray-900 ">
      <Navbar />
      <header class="container  text-right">
        <button @click="darkMode = !darkMode" class="focus:outline-none p-1 ml-auto flex px-2 rounded-lg text-gray-700 bg-transparent hover:bg-gray-300 dark:text-cyan-700 mb-2 mt-0 lg:mt-2 ">
          <svg fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" stroke="currentColor" class="h-6 w-6 ">
            <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
          </svg>
          : {{ darkMode ? "dark" : "light" }}
        </button>
      </header>
      <router-view />
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue"
export default {
  name: "App",
  data() {
    return {
      darkMode: false,
    }
  },
  components: {
    Navbar,
  },
}
</script>
